<template>
  <div class="container-fluid px-0">
    <div class="row">
      <div class="col-12 col-lg-4">
        <b-card>
          <div
            id="dashboard-download-btn"
            class="card-padding d-flex justify-content-between align-items-center pb-1"
          >
            <span class="header-card__text">Latest Configuration</span>
            <atom-button
              buttonId="download-config"
              @click="clickDownloadButton"
            >
              <feather-icon size="16" icon="DownloadIcon" />
            </atom-button>
          </div>
          <div class="mb-2 configuration_container">
            <div v-for="(item, index) of latestConfiguration" :key="index">
              <molecule-dashboard-configuration-item
                :dataItem="item"
                @onClickCompareConfiguration="onClickCompareConfiguration"
              ></molecule-dashboard-configuration-item>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-12 col-lg-8 pl-lg-0">
        <div>
          <b-card>
            <div class="card-padding">
              <span class="header-card__text">Recently use template</span>
            </div>
            <div class="card-padding p-0">
              <b-table
                sticky-header
                responsive
                :items="templateList"
                :fields="templateFields"
                :hover="true"
                class="template__table template_container"
                @row-clicked="selectRowTemplate"
              >
                <template #cell(template)="data">
                  <div class="d-flex">
                    <div class="header">{{ data.value.name }}</div>
                    <div :id="'tag-popover' + data.item.id">
                      <feather-icon
                        icon="TagIcon"
                        size="12"
                        class="tag-icon--style"
                      />
                    </div>
                    <b-popover
                      ref="popover"
                      :target="'tag-popover' + data.item.id"
                      triggers="hover"
                      placement="right"
                      container="my-container"
                      boundary="window"
                    >
                      <template v-slot:title>
                        <div
                          class="d-flex justify-content-between align-items-left"
                        >
                          <span>Tags</span>
                        </div>
                      </template>
                      <div class="badge__container">
                        <b-badge
                          v-for="(tag, index) in data.value.tag"
                          :key="index"
                          variant="light-primary"
                          class="badge--style tag--space"
                        >
                          {{ tag }}
                        </b-badge>
                      </div>
                    </b-popover>
                  </div>
                </template>
                <template #cell(description)="data">
                  <div class="custom-text-normal">{{ data.value }}</div>
                </template>
                <template #cell(compareIcon)="data">
                  <atom-button
                    buttonId="button-compare"
                    buttonStyle="border"
                    class="custom-text-normal"
                    @click="generateTemplate(data)"
                    >Generate</atom-button
                  >
                </template>
              </b-table>
            </div>
          </b-card>
        </div>
        <div>
          <b-card class="backup-status-table__container" no-body>
            <div class="card-padding">
              <span class="header-card__text">Backup Status</span>
            </div>
            <div>
              <div class="row">
                <div class="col-12">
                  <b-table
                    sticky-header
                    responsive
                    :items="backupList"
                    :fields="backupFields"
                    :hover="true"
                    class="backup__table backup_container"
                    @row-clicked="selectRowBackup"
                  >
                    <template #cell(nodeName)="data">
                      <div class="sub-header">{{ data.value }}</div>
                    </template>
                    <template #cell(ipAddress)="data">
                      <div class="custom-text-normal">{{ data.value }}</div>
                    </template>
                    <template #cell(pingStatus)="data">
                      <b-badge
                        pill
                        :variant="
                          data.value === 'DOWN'
                            ? 'light-danger'
                            : 'light-success'
                        "
                        class="badge--width text--small-size"
                        >{{ data.value }}</b-badge
                      >
                    </template>
                    <template #cell(backupStatus)="data">
                      <span
                        class="custom-text-normal"
                        :class="{
                          'custom-text-danger': data.value === 'FAILED',
                        }"
                        >{{ data.value }}</span
                      >
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <div class="row card-padding d-flex align-items-center">
              <div class="col-6">Showing {{ backupFilter.total }} entries</div>
              <div class="col-6 d-flex justify-content-end">
                <b-pagination
                  v-model="backupFilter.currentPage"
                  :total-rows="backupFilter.total"
                  :per-page="backupFilter.perPage"
                  size="sm"
                  class="my-0"
                ></b-pagination>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
    <molecule-modal-dialog
      modalId="modal-confirm--download-latest-config"
      :isTextCenter="true"
      :textTitle="`Do you want to download \nlatest configuration from all nodes ?`"
      buttonTextLeft="Download"
      @clickButtonLeft="clickConfirmDownloadFromModal"
    ></molecule-modal-dialog>
  </div>
</template>

<script>
import { BCard, BTable, BPagination, BBadge, BPopover } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeDashboardConfigurationItem from "@/components/molecules/networkConfigurationManagement/MoleculeDashboardConfigurationItem.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"

export default {
  name: "OrganismDashboard",
  components: {
    AtomButton,
    BCard,
    BTable,
    BPagination,
    BBadge,
    BPopover,
    MoleculeDashboardConfigurationItem,
    MoleculeModalDialog,
  },
  props: {
    latestConfiguration: {
      type: Array,
      required: true,
    },
    templateFields: {
      type: Array,
      required: true,
    },
    templateList: {
      type: Array,
      required: true,
    },
    backupFields: {
      type: Array,
      required: true,
    },
    backupList: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  emits: ["onClickCompareConfiguration"],
  data() {
    return {
      modalId: null,
    }
  },
  computed: {
    backupFilter: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
  methods: {
    clickDownloadButton() {
      this.openModal("modal-confirm--download-latest-config")
    },

    clickConfirmDownloadFromModal() {
      this.$emit("onRequestDownloadAllLatestConfig")
      this.closeModal()
    },

    generateTemplate(data) {
      this.$router.push(
        `/network-configuration/configuration-template/use-template/${data.item.id}`
      )
    },

    selectRowTemplate(record) {
      this.$router.push(
        `/network-configuration/configuration-template/${record.id}`
      )
    },

    selectRowBackup(record) {
      this.$router.push(`/network-configuration/node-management/${record.id}`)
    },

    onClickCompareConfiguration(nodeId, version) {
      this.$emit("onClickCompareConfiguration", nodeId, version)
    },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },
  },
}
</script>

<style lang="scss" scoped>
#dashboard-download-btn::v-deep .btn {
  padding: 8px 10px;
}

.card-body {
  padding: 0;
}

.card-padding {
  padding: 1.5rem;
}

.card {
  margin-bottom: 1rem;
}

.header-card__text {
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  color: #5e5873;
}

.header {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #6e6b7b;

  overflow-wrap: break-word;
  word-break: break-word;
}

.sub-header {
  font-weight: 400;
  font-size: 12px;
  color: #6e6b7b;
}

.tag-icon--style {
  color: #9d95f5;
  margin-left: 8px;
  margin-bottom: 3px;
}
.badge__container {
  min-width: 200px;
  width: auto;
}
.badge--style {
  max-width: 30ch;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tag--space {
  margin-left: 4px;
  margin-bottom: 4px;
}
.value__container {
  display: flex;
}

.template__table {
  height: 360px;
  overflow-y: auto;
}

.configuration_container {
  max-height: 300px;
  overflow-y: auto;
}

.template_container,
.backup_container {
  max-height: 500px;
  overflow-y: auto;
}

.backup-status-table__container,
.backup_container {
  overflow-x: hidden;
}

.backup-status-table__container {
  margin-bottom: 1rem;
}

.custom-text-normal {
  font-size: 12px;
}

.custom-text-danger {
  color: #ea5455;
  font-weight: 600;
}

.text--small-size {
  font-size: 10px;
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .configuration_container {
    height: calc(100vh - 18.75rem);
    max-height: calc(100vh - 18.75rem);
    overflow-y: auto;
  }

  .template_container {
    height: calc(50vh - 12.6rem);
    max-height: calc(50vh - 12.6rem);
    overflow-y: auto;
  }

  .backup_container {
    height: calc(50vh - 13.4rem - 45px);
    max-height: calc(50vh - 13.4rem);
    overflow-x: hidden;
  }

  .backup-status-table__container {
    margin-bottom: 0px;
  }
}
</style>
